export const fileConstants = {
    FILE_UPLOAD_REQUEST: 'FILE_UPLOAD_REQUEST'
  , FILE_UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS'
  , FILE_UPLOAD_FAILURE: 'FILE_UPLOAD_FAILURE'
};
